<div
    class="option-row"
    [ngClass]="{
        'option-row--child-is-checked':
            value === _parent.value || (value?.id === _parent.value?.id && value?.id !== undefined)
    }"
>
    <label
        role="button"
        tabindex="0"
        class="config-option"
        [class.config-option--not-available]="!isAvailable"
        [class.config-option--small]="!description"
        [class.config-option--has-amount]="amount !== undefined"
        [class.isChecked]="value === _parent.value || (value?.id === _parent.value?.id && value?.id !== undefined)"
    >
        <div class="config-option__aside">
            <span class="config-option__amount" *ngIf="amount !== undefined">
                {{ amount | tenantCurrency: '1.0-0' }}
            </span>
            <span class="config-option__radio">
                <mg-ui-checkmark></mg-ui-checkmark>
            </span>
        </div>
        <div class="config-option__main">
            <input type="radio" tabindex="-1" [name]="_parent.name" [value]="value" [(ngModel)]="_parent.value" />

            <div class="config-option__name">{{ label }}</div>
            <span *ngIf="!!description" class="config-option__description" [innerHtml]="description"> </span>
            <ng-content></ng-content>
        </div>
    </label>
    <ng-content class="modal" select="mg-ui-modal"></ng-content>
</div>
